import { render, staticRenderFns } from "./AdminSideMenu.vue?vue&type=template&id=0e788556"
import script from "./AdminSideMenu.vue?vue&type=script&lang=js"
export * from "./AdminSideMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminSideMenu.vue?vue&type=style&index=0&id=0e788556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports